module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-bored.cc6033f5.png";